<template>
  <div class="cols-options-setting-dialog">
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')" title="尺寸" name="4">
        <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')">
          <div class="verticallyCenter">
            <div class="verticallyCenter mr12 flex1">
              <span class="fs14 mr8 color000">宽</span>
              <el-input type="number" value="-" disabled style="width: 100%" v-model="showWidthVal">
                <template slot="suffix">
                  <span class="suffix_text">%</span>
                </template>
              </el-input>
            </div>
            <div class="verticallyCenter flex1">
              <span class="fs14 mr8 color000">高</span>
              <single-input
                style="width: 100%"
                :value.sync="showHeightVal"
                inputSuffixs="%"
              />
<!--              <el-input-->
<!--                type="number"-->
<!--                value="-"-->
<!--                style="width: 100%"-->
<!--                v-inputHandle="{ this1, type: 'showHeightVal' }"-->
<!--                v-model="showHeightVal"-->
<!--              >-->
<!--                <template slot="suffix">-->
<!--                  <span class="suffix_text">%</span>-->
<!--                </template>-->
<!--              </el-input>-->
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        v-if="checkShowTabs('排列') && !disableSetColAndRow"
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
        title="排列"
        name="1"
      >
        <div class="content" v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')">
          <div class="content-item mb16">
            <emptyLayoutComponent />
          </div>
          <!--          反馈，说有bug，修复后放开-->
<!--                    <autoLayoutSetting-->
<!--                      :options="activeCol.componentBoxOptions"-->
<!--                      :elementOptions="activeCol.elementOptions"-->
<!--                      :ids="ids"-->
<!--                      @update="handleSet"-->
<!--                    />-->
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
        v-if="checkShowTabs('外观')"
        title="外观"
        name="2"
      >
        <div v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')">
          <div class="content-item">
            <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
          </div>
          <div class="setting-item setting-item-grid mt16">
            <radiusSetting :options="activeCol.componentBoxOptions" :ids="ids" @update="handleSet" />
          </div>
          <div class="setting-item">
            <borderSetting
              ref="borderSetting"
              :options="activeCol.componentBoxOptions"
              :ids="ids"
              @update="handleSet"
            />
          </div>
          <div class="setting-item">
            <backGroundSetting :options="activeCol.componentBoxOptions" :ids="ids" @update="handleSet" />
          </div>
          <div class="setting-item mt16">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="boxShadowH"
              :boxShadowV.sync="boxShadowV"
              :boxShadowBlur.sync="boxShadowBlur"
              :boxShadowSpread.sync="boxShadowSpread"
              :boxShadowColor.sync="boxShadowColor"
            />
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
        v-if="checkShowTabs('边距')"
        title="边距"
        name="3"
      >
        <paddingSetting :options="activeCol.componentBoxOptions" :ids="ids" @update="handleSet" />
      </el-collapse-item>
      <el-collapse-item
          @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
          v-if="disableSetColAndRow"
          title="高级设置"
          name="5"
      >
        <autoLayoutSetting
          :options="activeCol.componentBoxOptions"
          :elementOptions="activeCol.elementOptions"
          :ids="ids"
          @update="handleSet"
        />
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import radiusSetting from "./setting/radiusSetting.vue"
import backGroundSetting from "./setting/backGroundSetting.vue"
import borderSetting from "./setting/borderSetting.vue"
import paddingSetting from "./setting/paddingSetting.vue"
import autoLayoutSetting from "./setting/autoLayoutSetting.vue"
import emptyLayoutComponent from "../emptyLayoutComponentBigScreen/emptyLayoutComponent.vue"
import { handleFindLayoutComponentOptionsCols, handleFindLayoutComponentColsParentRowByUid } from "../../../utils"
import { withMethodsHistoryCombine } from "utils/revork"
import { CATEGORY_MODE } from "@/consts"
export default withMethodsHistoryCombine({
  components: {
    emptyLayoutComponent,
    paddingSetting,
    radiusSetting,
    borderSetting,
    backGroundSetting,
    autoLayoutSetting
  },
  props: {
    options: { type: Object },
    container_id: { type: [Number, String] },
    rect_id: { type: [Number, String] }
  },
  data() {
    return {
      activeNames: ["1", "2", "4"],
      collapseActiveNames: ["1", "2", "4", "5"],
      this1: this
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    showColsSetting() {
      if (this.options.hasOwnProperty("showColsSetting") === false) return true
      return this.options.showColsSetting
    },
    activeCol() {
      const rectAttr = this.getRectAttribute.call(this, this.ids)
      const useActiveIndex = rectAttr.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rectAttr.options.activeIndex
      const pOptions = [rectAttr.options.rows[useActiveIndex]]
      return handleFindLayoutComponentOptionsCols(pOptions, this.ids.uid)
    },
    disableSetColAndRow() {
      return this.hasProperty(this.options, "disableSetColAndRow")
    },
    boxShadowColor: {
      get() {
        return this.checkAndSetPrimaryVal(this.activeCol.componentBoxOptions, "boxShadowColor", "boxShadowColor", [
          "rgba(255,255,255,1)"
        ])
      },
      set(newVal) {
        this.handleSet("boxShadowColor", newVal)
      }
    },
    boxShadowH: {
      get() {
        return this.checkAndSetPrimaryVal(this.activeCol.componentBoxOptions, "boxShadowH", "boxShadowH", 0)
      },
      set(newVal) {
        this.handleSet("boxShadowH", newVal)
      }
    },
    boxShadowV: {
      get() {
        return this.checkAndSetPrimaryVal(this.activeCol.componentBoxOptions, "boxShadowV", "boxShadowV", 0)
      },
      set(newVal) {
        this.handleSet("boxShadowV", newVal)
      }
    },
    boxShadowBlur: {
      get() {
        return this.checkAndSetPrimaryVal(this.activeCol.componentBoxOptions, "boxShadowBlur", "boxShadowBlur", 0)
      },
      set(newVal) {
        this.handleSet("boxShadowBlur", newVal)
      }
    },
    boxShadowSpread: {
      get() {
        return this.checkAndSetPrimaryVal(this.activeCol.componentBoxOptions, "boxShadowSpread", "boxShadowSpread", 0)
      },
      set(newVal) {
        this.handleSet("boxShadowSpread", newVal)
      }
    },
    getOptions: function () {
      return this.getRectAttribute.call(this, this.ids).options
    },
    showWidthVal: {
      get() {
        return Math.floor(this.width)
      },
      set(newVal) {
        this.width = newVal
      }
    },
    showHeightVal: {
      get() {
        return Math.floor(this.height)
      },
      set(newVal) {
        this.height = newVal
      }
    },
    width: {
      get() {
        return parseFloat(this.activeCol.width)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal + "%", "width", false)
      }
    },
    height: {
      get() {
        const useActiveIndex = this.getOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
        const pOptions = [this.getOptions.rows[useActiveIndex]]
        // 查找当前选中col的父级row
        let result = handleFindLayoutComponentColsParentRowByUid(pOptions, this.activeCol.uid)
        return result?.height?.slice(0, -1)
      },
      set(newVal) {
        const useActiveIndex = this.getOptions.categoryMode === CATEGORY_MODE.SAME ? 0 : this.getOptions.activeIndex
        const pOptions = [this.getOptions.rows[useActiveIndex]]
        let row = handleFindLayoutComponentColsParentRowByUid(pOptions, this.activeCol.uid)
        this.$store.dispatch(this.request_prefix + "/changeRowColSize", {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          type: "height",
          row: row,
          val: newVal + "%"
        })
      }
    },
    opacity: {
      get() {
        return this.checkAndSetPrimaryVal(this.activeCol.componentBoxOptions, "opacity", "opacity", 100)
      },
      set(newVal) {
        this.handleSet("opacity", newVal)
      }
    }
  },
  methods: {
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH) || !Array.isArray(this.boxShadowColor)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
    checkShowTabs(name) {
      if (typeof this.showColsSetting === "boolean") return this.showColsSetting
      return !!this.showColsSetting.find(it => it === name)
    },
    handleSet(key, val) {
      if (this.activeCol.componentBoxOptions[key] === val && typeof val !== "object") return
      this.$changeOptionsEV(val, key, false, null, this.ids)
    }
  }
})
</script>

<style scoped></style>
